import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n.ts'; // Initialize i18n
import languageService from './services/languageService.ts';
import App from './App.tsx';


// Initialize language as early as possible
languageService.initializeLanguage();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
